import React, {useState, useEffect, useRef, lazy, Suspense} from "react";
import { useTranslate } from 'react-redux-multilingual';
// import {CardInfoArticle} from "@gull";
import axios from 'axios'
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
const CardInfoArticle = lazy (() => import("../../../@gull/components/cards/CardInfoArticle"));
const CardInfoArticleGeneric = lazy (() => import("../../../@gull/components/cards/CardInfoArticleComp/CardInfoArticleGeneric"));

// Sans wmsid (ERP/Facturation) : pas de section courante, on utilise l'API de stock multi-section
// déjà exploitée par la fiche article (large_stock), qui n'exige pas de section obligatoire.
const useLoad = (wmsid) => {
    const [apiError,setApiError] = useState(false)
    const [article,setArticle]=useState({})
    const [show,setShow] = useState(false)
    const [loading,setLoading] = useState(false)

    useEffect(function () {
        (async function() {
            if(show){
                setApiError(false)
                setLoading(true)
                const url = wmsid
                    ? process.env.REACT_APP_API_URL+"api/erp/article/article_id_in_section/"+show+'/'+wmsid
                    : process.env.REACT_APP_API_URL+"api/erp/article/large_stock/"+show
                const response = await axios.get(url
                ).then((response) => {
                    if(!response.data.valid){
                        setLoading(false)
                        setApiError('articleNoReferenceFind')
                    }else{
                        setArticle(wmsid ? response.data.data : {by_section: response.data.by_section})
                        setLoading(false)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    if(error.response==undefined){
                        setApiError('unknowError')
                    }
                    else if(error.response.status==403){
                        setApiError('forbiddenGeneral')
                    }
                    else {
                        setApiError('unknowError')
                    }
                    setLoading(false)
                })
            }
        })()
    }, [show])

    return [loading,apiError,article,setArticle,setShow,show]
}

const BtnItemBlockInfo = (props) =>{
    const t = useTranslate();
    const [loading,apiError,article,setArticle,setShow,show] =useLoad(props.wmsid)
    const [editUpc,setEditUpc]=useState(false)
    const inputRef = useRef('')

    const handleClick = () => {
        if(props.setHideInput) props.setHideInput(true)
        setShow(props.articleId)
        if (props.setModalOpened) props.setModalOpened(true)
    };

    const closeModal = () => {
        if(props.setHideInput) props.setHideInput(false)
        setShow(false)
        if (props.setModalOpened) props.setModalOpened(false)
    };
    
    return(
        <div>
            <Modal show={show} onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.articleName || (Object.keys(article).length!=0 && article.article ? article.article.name : '')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ?
                        <span className="d-flex justify-content-center mt-1"><div className="spinner-border spinner-border-sm"></div></span>
                    :
                        <span>
                            {(apiError) &&
                                <p className="text-danger text-center mt-3"><strong>{t(apiError)}</strong></p>
                            }
                            {(Object.keys(article).length!=0) ?
                                <span className="position-relative">
                                    <Suspense>
                                        {props.wmsid ?
                                            <CardInfoArticle
                                                article={article}
                                                wmsid={props.wmsid}
                                                editUpc={editUpc}
                                                inputRef={inputRef}
                                                setEditUpc={setEditUpc}
                                                setArticle={setArticle}
                                            />
                                        :
                                            <CardInfoArticleGeneric
                                                articleName={props.articleName}
                                                image={props.image}
                                                bySection={article.by_section}
                                            />
                                        }
                                    </Suspense>
                                </span>
                            :
                                false}
                        </span>
                    }
                </Modal.Body>
            </Modal>
            {(props.image && props.image!=null) ?
                <img className="vignetteBaseArticle" src={props.image.split(';')[0]} alt={props.articleName} onClick={()=>handleClick()}/>
            :
                <FontAwesomeIcon 
                    icon={faEye} 
                    className="text-info pointer"
                    onClick={()=>handleClick()}
                />
            }
        </div>
    )
}

export default BtnItemBlockInfo;